<template>
    <vs-popup classContent="popup-example" :title="translate('AddKey')" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Key')" v-model="params.placeholder" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('English')" v-model="params.value_en" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Russian')" v-model="params.value_ru" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button color="success" type="border" @click.stop="getTranslation()">{{translate('Translate')}}</vs-button>
          &nbsp;
          <vs-button @click="submitForm()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['closePopups','params','popUps','openAlert','submitForm'],
    data() {
        return {}
    },
    methods:{
      translate: function(key){
        return this.$t(key);
      },
        getTranslation: function(){
            let that = this;
            this.$vs.loading();
            const str = '?source=en&target=ru&text='+this.params.value_en;
            axios.get("/api/dictionary"+str)
            .then((data) => {
              that.$vs.loading.close();
              that.$set(that.params,'value_ru',data.data.text); 
            })
            .catch((error) => { console.log('error',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
        }
    }
}
</script>